import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';
import { MyAccountTeamsQuery } from '@/gql/graphql';

const GetMyAccountTeamsQuery = graphql(`
  query MyAccountTeams($pagination: PaginationInput) {
    me {
      user {
        account {
          teams(pagination: $pagination) {
            items {
              id
              name
            }
          }
        }
      }
    }
  }
`);

const useGetMyAccountTeams = (
  options?: Partial<UseQueryOptions<MyAccountTeamsQuery>>
) => {
  const { data, ...rest } = useQuery({
    ...options,
    queryKey: meKeys.accountTeams(),
    queryFn: () => {
      // Fetch a single page at the server's max limit. Accounts with more than
      // 100 teams would have the rest silently dropped from the rail. If that
      // becomes a real case, convert this to `useInfiniteQuery` (select
      // `totalCount` and page via offset) and add a "Load more" control to the
      // TeamsRail.
      return gqlClient.request(GetMyAccountTeamsQuery, {
        pagination: { limit: 100, offset: 0 },
      });
    },
  });

  return { data: data?.me.user.account.teams.items, ...rest };
};

export default useGetMyAccountTeams;
